function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M214863 191624c31496 4258 58717 12407 78085 23042 22002 12081 34943 27934 34943 46127 0 22498-20174 41633-52791 54383-28699 11219-68019 18157-111155 18157s-82456-6939-111155-18157C20174 302426-1 283291-1 260793c0-18442 13313-34488 35887-46636 19852-10684 47748-18803 79955-22888l3470 27430c-28757 3648-53275 10687-70306 19852-13367 7193-21250 14949-21250 22242 0 9900 13420 20097 35118 28578 25615 10013 61330 16206 101072 16206 39743 0 75457-6193 101072-16206 21698-8481 35118-18678 35118-28578 0-7140-7601-14746-20523-21841-16513-9068-40360-16102-68436-19898l3686-27430zm-37637-71282v137996h-27756V120342c-26983-6282-47086-30481-47086-59377C102384 27295 129678 0 163349 0c33670 0 60965 27294 60965 60965 0 28896-20104 53095-47087 59377z",
  fillRule: "nonzero"
});

var SvgContactLocation = function SvgContactLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 327891 333333",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_location.26f7620d.svg";
export { ForwardRef as ReactComponent };